import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { EstimateDefModel, EstimateModel } from "../models/estimate.model";
import { GenericEstimateModel } from "../models/generic-estimate.model";
import { EstGroupsListModel } from "../models/est-groups.model";
import { PetProcsModel } from "../models/pet-proc.model";
import { UserService } from "./user.service";

@Injectable({
    providedIn: "root"
})
export class EstimateService {

    private baseUrl: string = 'pet';

    est_groups_list: EstGroupsListModel[] = [];
    new_est_group: EstGroupsListModel = new EstGroupsListModel(0, 0, '', '', '', '', '');
    pet_estimates: EstimateModel[] = [];
    pet_generic_estimates: EstimateModel[] = [];
    estimate_def: EstimateDefModel[] = [];
    generic_estimates: GenericEstimateModel[] = [];
    pet_procs: PetProcsModel[] = [];

    constructor(
        private api: ApiService,
        private userService: UserService
    ) { }

    getEstGroupsList(pet_no: number,) {
        return new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/getEstGroupsList?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.est_groups_list = res.data.map((element) => {
                            return new EstGroupsListModel(
                                element.ID,
                                element.pet_no,
                                element.description,
                                element.type,
                                element.date_created,
                                element.remarks,
                                element.created_by,
                                element.total
                            );
                        });
                        resolve(1);
                    } else {
                        this.est_groups_list = [];
                        resolve(0);
                    }
                });
        });
    }


    getProcsByPetId(pet_no: number, group_no?: number) {
        const clinic_no = this.userService.userData.clinic_no;
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getestprocsbypetid?pet_no=${pet_no}&clinic_no=${clinic_no}&group_no=${group_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_procs = []
                        this.pet_procs = res.data.map((element) => {
                            return new PetProcsModel(element.tran_sequence, element.sup_sequence, element.link_no, element.link_type, element.item_type, element.unit, element.unit_cost, element.status, element.inv_date, element.req_date, element.appr_date, element.done_date, element.req_by, element.req_employee_initial, element.done_by, element.done_employee_initial, element.appr_by, element.appr_employee_initial, element.inv_by, element.inv_employee_initial, element.pstatus, element.tax, element.response1, element.response2, element.approval, element.chk_cost, element.cost, element.sub_cost, element.distr_method, element.route, element.start_time, element.moved, element.printed, element.recall_date, element.clinic_no, element.optional, element.rerequest, element.location, element.basechg, 0, 0, element.code_name, element.procedure_desc, element.pet_no, element.client_no, element.link_name, element.link_desc, element.link_fix, element.wtime, element.supervisor, element.attending, element.visible, element.dosage, element.days, element.altdays, element.frequency, element.indicationID, element.qty, element.notes, element.remain_times, element.dosage_unit, element.children);
                        });

                        resolve(1);
                    } else {
                        this.pet_procs = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupEstGroup(model: EstGroupsListModel, action_type: number) {
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupEstGroup?action_type=${action_type}`, model)
                .subscribe((res: any) => {
                    if (res.data > 0) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
    }












    //-------------------------------- Est Groups --------------------------------





    setupPetEstimate(estimate: EstimateModel) {
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetEstimate`, estimate)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
    }

    setupPetEstimateGeneric(estimate: EstimateModel) {
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetEstimate`, estimate)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
    }

    deletePetEstimate(item: EstimateModel) {
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePetEstimate`, item)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
    }

    getEstimatesByPetId(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEstimatesByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_estimates = res.data
                            .filter((element) => element.pet_no != 0)
                            .map((element) => {
                                return new EstimateModel(
                                    element.estimate_sequence,
                                    element.pet_no,
                                    element.estimate_name,
                                    element.date_added,
                                    element._total_charge,
                                    element.estimate_note,
                                    []
                                );
                            });

                        this.pet_generic_estimates = res.data
                            .filter((element) => element.pet_no == 0)
                            .map((element) => {
                                return new EstimateModel(
                                    element.estimate_sequence,
                                    element.pet_no,
                                    element.estimate_name,
                                    element.date_added,
                                    element._total_charge,
                                    element.estimate_note,
                                    []
                                );
                            });

                        resolve(1);
                    } else {
                        this.pet_estimates = [];
                        this.pet_generic_estimates = [];
                        resolve(0);
                    }
                }, (error) => {
                    this.pet_estimates = [];
                    this.pet_generic_estimates = [];
                    reject(error);
                });
        });
    }

    getEstimatesDetail(estimate_def_sequence: number, clinic_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetEstimatesDetail?estimate_def_sequence=${estimate_def_sequence}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.estimate_def = res.data.map((element) => {
                            return new EstimateDefModel(
                                element.estimate_def_sequence,
                                element.dept_estimate_sequence,
                                element.link_no,
                                element.link_type,
                                element.link_count,
                                element.link_cost,
                                element.defined,
                                element.status,
                                element.code_name,
                                element.procedure_desc,
                                element.code_category,
                                element.type
                            );
                        });
                        resolve(1);
                    } else {
                        this.estimate_def = [];
                        resolve(0);
                    }
                }, (error) => {
                    this.estimate_def = [];
                    reject(error);
                });
        });
    }

    getGenericEstimates() {
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`catalog/?type=${4}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.generic_estimates = res.data.map((element) => {
                            return new GenericEstimateModel(
                                element.estimate_sequence,
                                element.estimate_name,
                                element.date_added,
                                element.total_charge
                            );
                        });
                        resolve(1);
                    } else {
                        this.generic_estimates = [];
                        resolve(0);
                    }
                }, (error) => {
                    this.generic_estimates = [];
                    reject(error);
                });
        });
    }
}

